/**
     * @desc 查询NFT合约
传入collection的id，查询NFT合约信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/nftContract/getNFTContractByCollectionId', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/nftContract/getNFTContractByCollectionId', params);
}
